module.exports = __webpack_public_path__ + "static/img/Gaman.1167747.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/Gaman.jpg
// module id = Jfq3
// module chunks = 1